import React from "react";

import { useToggleModal } from "../../../lib/hooks/useToggleModal";
import { useDateTimeDevices } from "../lib/useDateTimeDevices";

import { Button } from "../../shared/Button/Button";
import { Icon } from "../../shared/Icon/Icon";
import { DeviceTimeWizard } from "./DeviceTimeWizard";

// Enabled when the account has a paired device that supports Date & time settings.
// Kept apart from the Devices page so the account-wide query only re-renders
// this button.
interface Props {
  refetch?: () => void;
  variant?: "toolbar" | "text";
}

export const SetDeviceTimeButton = ({
  refetch,
  variant = "toolbar",
}: Props) => {
  const { devices } = useDateTimeDevices();
  const { isOpen, toggleModal } = useToggleModal();
  // Date & time is Room Display X only, so paired means assigned to a room
  const hasPairedDevice = devices.some((device) => !!device.room);

  return (
    <div
      className={
        variant === "text" ? "SetDeviceTimeButton--text" : "SetDeviceTimeButton"
      }
    >
      {variant === "text" ? (
        <Button
          type="button"
          color="simple"
          disabled={!hasPairedDevice}
          onClick={toggleModal}
        >
          <span>Edit date and time for multiple devices</span>
          <span aria-hidden="true">
            <Icon icon="arrow-up-right-simple" />
          </span>
        </Button>
      ) : (
        <Button
          type="button"
          size="medium"
          color="outline-secondary"
          icon="globe-clock-icon"
          title="Set device time"
          // The title is hidden on smaller screens, where only the icon shows
          aria-label="Set device time"
          tooltip="Edit date and time settings for multiple devices"
          disabled={!hasPairedDevice}
          onClick={toggleModal}
        />
      )}

      {isOpen ? (
        <DeviceTimeWizard
          devices={devices}
          onClose={toggleModal}
          refetch={refetch}
        />
      ) : null}
    </div>
  );
};
